import React from 'react';
import MultiSelectFilter from './MultiSelectFilter';
import DateInput from './DateInput';

export const EMPTY_FILTERS = {
  search: '',
  type: '',
  start: '', end: '',
  pot_exit: { mode: 'include', ids: [] },
  pot_entry: { mode: 'include', ids: [] },
  account_exit: { mode: 'include', ids: [] },
  account_entry: { mode: 'include', ids: [] },
  revenue_source: { mode: 'include', ids: [] },
  entity: { mode: 'include', ids: [] },
  tag: { mode: 'include', ids: [] },
};

export function filtersToParams(f) {
  const p = {};
  if (f.search) p.search = f.search;
  if (f.type) p.type = f.type;
  if (f.start) p.start = f.start;
  if (f.end) p.end = f.end;
  const pairs = [
    ['pot_exit', 'pot_exit_in', 'pot_exit_out'],
    ['pot_entry', 'pot_entry_in', 'pot_entry_out'],
    ['account_exit', 'account_exit_in', 'account_exit_out'],
    ['account_entry', 'account_entry_in', 'account_entry_out'],
    ['revenue_source', 'revenue_source_in', 'revenue_source_out'],
    ['entity', 'entity_in', 'entity_out'],
  ];
  for (const [k, inKey, outKey] of pairs) {
    const v = f[k];
    if (v?.ids?.length) p[v.mode === 'exclude' ? outKey : inKey] = v.ids.join(',');
  }
  if (f.tag?.ids?.length) p[f.tag.mode === 'exclude' ? 'tag_ids_out' : 'tag_ids'] = f.tag.ids.join(',');
  return p;
}

/**
 * Counts how many filters are currently applied (excluding the free-text
 * search which sits in the header bar).
 */
export function countActiveFilters(f) {
  let n = 0;
  if (f.type) n++;
  if (f.start) n++;
  if (f.end) n++;
  for (const k of ['pot_exit','pot_entry','account_exit','account_entry','revenue_source','entity','tag']) {
    if (f[k]?.ids?.length) n++;
  }
  return n;
}

export default function FilterBar({ filters, onChange, pots, accounts, entities, sources, tags }) {
  const upd = (k, v) => onChange({ ...filters, [k]: v });
  return (
    <div className="card p-5 space-y-4">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div>
          <label className="text-sm text-slate-600 dark:text-slate-400 mb-1 block">Tipo</label>
          <select value={filters.type} onChange={(e) => upd('type', e.target.value)} className="input-md">
            <option value="">Todos</option>
            <option value="income">Receita</option>
            <option value="expense">Despesa</option>
            <option value="transfer">Transferência</option>
          </select>
        </div>
        <MultiSelectFilter label="Pote Saída" options={pots} value={filters.pot_exit} onChange={(v) => upd('pot_exit', v)} />
        <MultiSelectFilter label="Pote Entrada" options={pots} value={filters.pot_entry} onChange={(v) => upd('pot_entry', v)} />
        <MultiSelectFilter label="Conta Saída" options={accounts} value={filters.account_exit} onChange={(v) => upd('account_exit', v)} />
        <MultiSelectFilter label="Conta Entrada" options={accounts} value={filters.account_entry} onChange={(v) => upd('account_entry', v)} />
        <MultiSelectFilter label="Fonte de Receita" options={sources} value={filters.revenue_source} onChange={(v) => upd('revenue_source', v)} />
        <MultiSelectFilter label="Pessoa/Entidade" options={entities} value={filters.entity} onChange={(v) => upd('entity', v)} />
        <MultiSelectFilter label="Tag" options={tags} value={filters.tag} onChange={(v) => upd('tag', v)} allowNenhum={false} />
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div>
          <label className="text-sm text-slate-600 dark:text-slate-400 mb-1 block">Data Inicial</label>
          <DateInput value={filters.start} onChange={(v) => upd('start', v || '')} />
        </div>
        <div>
          <label className="text-sm text-slate-600 dark:text-slate-400 mb-1 block">Data Final</label>
          <DateInput value={filters.end} onChange={(v) => upd('end', v || '')} />
        </div>
      </div>
    </div>
  );
}
